module.exports = __webpack_public_path__ + "img/placeholder.9065c58a.png";